import httpStore from "@/api/httpStore.js";
import decamelize from "decamelize";

export function getBanners() {
  return httpStore
    .get("banners")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function updateBanner(bannerId, newBanner) {
  newBanner = JSON.parse(decamelize(JSON.stringify(newBanner)));
  return httpStore
    .put(`banners`, {
      id: bannerId,
      newBanner: newBanner
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function createBanner(newBanner) {
  newBanner = JSON.parse(decamelize(JSON.stringify(newBanner)));
  return httpStore
    .post(`banners`, {
      newBanner: newBanner
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function requestDeleteBanner(id) {
  return httpStore
    .delete(`banners?id=${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return {
        status: "error",
        message: e.response?.data?.message || e.message
      };
    });
}
